import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bring_front",
  "use": "icon-bring_front-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bring_front\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10,13H6V12h4Zm3-1v1h4V12ZM12,8.4,13.62,10l.71-.71L11.5,6.48,8.67,9.31l.71.71L11,8.4V14H6v3H17V14H12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol